export const stages = {
  UNINITIALIZATED: 'UNINITIALIZATED',
  BOOTSTRAPPING: 'BOOTSTRAPPING',
  INITIALIZED: 'INITIALIZED',
  FAILED: 'FAILED'
}
